// client/src/features/insurance/enums.ts — the policy vocabulary SCR-INS-001 renders ·
// MAINT-009.
//
// `as const satisfies readonly InsuranceType[]` is the shape every module uses: the array is a
// literal tuple the `<select>` and the filter iterate, and the `satisfies` makes a member the
// contract renames a COMPILE error here rather than an option nobody can pick. The Romanian
// labels live under `enums.InsuranceType.*` — §9.6.3's one sanctioned computed key — and
// `__tests__/contract-parity.test.ts` fails on a member without one.

import type { InsuranceType } from '@/client';

/** 03 §11.6's three kinds of cover, in the order the form offers them. PAD is the obligatory one. */
export const INSURANCE_TYPES = ['PAD', 'FACULTATIVE', 'OTHER'] as const satisfies readonly InsuranceType[];

/**
 * The currencies a premium can be recorded in — the same three every money form in this app
 * offers (`EXPENSE_CURRENCIES`, `CONTRACT_CURRENCIES`), because `app.currencies` seeds exactly
 * these as active and `CreateInsuranceCommandHandler` refuses anything else with a 422.
 */
export const PREMIUM_CURRENCIES = ['RON', 'EUR', 'USD'] as const;

/** What `InsuranceInput.currency` defaults to when the form is left alone — `Money.DefaultCurrency`. */
export const DEFAULT_PREMIUM_CURRENCY = 'RON';
